import { render, staticRenderFns } from "./ComponentsView.vue?vue&type=template&id=00c7c63c"
import script from "./ComponentsView.vue?vue&type=script&lang=js"
export * from "./ComponentsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports